export const REDUCER_NAME="fbAdsSlice";

// Payload for creating an ad
export interface IFacebookAdCreateDTO {
  name: string;
  status: "ACTIVE" | "PAUSED" | "ARCHIVED" | "DELETED";
  adset_id: string;
  creative_id: string;
}

// Data returned by backend / Facebook API
export interface IFacebookAdDTO {
  id: string;
  name: string;
  status: "ACTIVE" | "PAUSED" | "ARCHIVED" | "DELETED";
  created_time: string;

  adset: {
    id: string;
  };

  campaign: {
    id: string;
  };

  creative: {
    id: string;
  };
}

// Redux state
export interface IFacebookAdsState {
  facebookAdsList: IFacebookAdDTO[] | null;
  isLoading: boolean;
  errorMessage: string | null;
}
